export const environment = {
	production: true,
	apiUrl: 'https://api.wrongopinions.moe',
};
